/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Reference_NumberInputs */

const en_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference Number`)
};

const es_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de referencia`)
};

const fr_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de référence`)
};

const de_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenznummer`)
};

const ja_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リファレンスナンバー(型番)`)
};

const zh_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参考编号`)
};

const ar_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرقم المرجعي`)
};

const id_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor Referensi`)
};

const it_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di Referenza`)
};

const ru_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер по каталогу (Ref.)`)
};

const pt_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de Referência`)
};

const ko_field_reference_number = /** @type {(inputs: Field_Reference_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레퍼런스 넘버 (참조 번호)`)
};

/**
* | output |
* | --- |
* | "Reference Number" |
*
* @param {Field_Reference_NumberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_reference_number = /** @type {((inputs?: Field_Reference_NumberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Reference_NumberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_reference_number(inputs)
	if (locale === "es") return es_field_reference_number(inputs)
	if (locale === "fr") return fr_field_reference_number(inputs)
	if (locale === "de") return de_field_reference_number(inputs)
	if (locale === "ja") return ja_field_reference_number(inputs)
	if (locale === "zh") return zh_field_reference_number(inputs)
	if (locale === "ar") return ar_field_reference_number(inputs)
	if (locale === "id") return id_field_reference_number(inputs)
	if (locale === "it") return it_field_reference_number(inputs)
	if (locale === "ru") return ru_field_reference_number(inputs)
	if (locale === "pt") return pt_field_reference_number(inputs)
	return ko_field_reference_number(inputs)
});